import React from 'react';
import PropTypes from 'prop-types';
import useIdentity from '../../hooks/use-identity';

export default function Can(props) {
  const {invert, permission, ability, children} = props;
  const {can} = useIdentity();
  let match = can(permission, ability);

  if (invert) {
    match = !match;
  }

  return match ? children : <></>;
}

Can.defaultProps = {
  invert: false,
  ability: 'can',
};

Can.propTypes = {
  /** Render the content if the user doesn't have the permission instead. */
  invert: PropTypes.bool,
  /** The id of the permission to check */
  permission: PropTypes.string.isRequired,
  /** The ability or abilities to check for. If an array is specified, contents will be rendered if any one matches (abililities treated as an "or"). Defaults to "can" */
  ability: PropTypes.oneOfType([PropTypes.oneOf(['read', 'update', 'create', 'delete', 'can']), PropTypes.array]),
  /** The content to render if the user has the ability. */
  children: PropTypes.node.isRequired,
};
